import React, {useEffect} from "react";
import {FormProvider, SubmitHandler, useForm} from "react-hook-form";
import SubTitle from "../../components/SubTitle";
import DangerEvaluationForm from "../dangerEvaluation/DangerEvaluationForm";
import ConfirmButtonGroup from "../../components/ConfirmButtonGroup";
import {useQueryClient} from "react-query";
import {useNavigate} from "react-router-dom";
import {useRecoilValue, useSetRecoilState} from "recoil";
import {snackBarState, snackBarToggleState} from "../../Recoil/Atom/snackBarState";
import {tokenSelector} from "../../Recoil/Atom/authState";
import {useCreateMutation, useGetItemQuery} from "../../hooks/useQueryHooks";
import {ResponseItem} from "../../models/clientModels/interfaces/Response";
import {
  WPEvaluationMaster,
  initializeEvaluataionMaster,
} from "../../models/serverModels/permission/WPEvaluationMaster";

import {
  initializeDangerEvaluation,
} from "../../models/serverModels/permission/WPDangerEvaluation";


import * as evaluationMasterApi from "../../api/permissionApi/evaluationMasterApi";
import * as Params from "../../models/clientModels/interfaces/apiParams";
import MWProgress from "../../components/MWProgress";
import {FormSection} from "../../styledComponents/StyledCreateForm";
import {Button} from "@mui/material";
import EvaluationMasterForm from "./EvaluationMasterForm";
const CreateDangerEvaluation = () => {
  const queryClient = useQueryClient();
  const navigate = useNavigate();
  const tokenState = useRecoilValue(tokenSelector);

  const setSnackBarState = useSetRecoilState(snackBarState);
  const setSnackBarToggle = useSetRecoilState(snackBarToggleState);

  const {data: NewMasterEvaluation, isLoading: isGetLoading} = useGetItemQuery<
    ResponseItem<WPEvaluationMaster>
  >({
    key: ["NewEvaluationMaster"],
    api: () => evaluationMasterApi.getCreate({token: tokenState}),
  });

  console.log("⚾ ~ CreateEvaluationMaster ~ NewEvaluationMaster:", NewMasterEvaluation);
  const {
    mutate: createMutate,
    isLoading,
    data: res,
  } = useCreateMutation<ResponseItem<WPEvaluationMaster>, Params.Create<WPEvaluationMaster>>({
    api: evaluationMasterApi.create,
    options: {
      onSuccess: async (res: ResponseItem<WPEvaluationMaster>) => {
        setSnackBarToggle(true);
        setSnackBarState("create");

        navigate(`/Permission/List/`);
        queryClient.invalidateQueries("EvaluationMasterList");
      },
      onError: () => {
        setSnackBarToggle(true);
        setSnackBarState("failed");
      },
    },
  });
  const methods = useForm<WPEvaluationMaster>({
    defaultValues: NewMasterEvaluation?.item || initializeEvaluataionMaster(),
  });
  const {reset} = methods;

  useEffect(() => {
    reset(NewMasterEvaluation?.item);
  }, [NewMasterEvaluation?.item, reset]);

  const onSubmit: SubmitHandler<WPEvaluationMaster> = (data) => {
    createMutate({
      token: tokenState,
      item: {...initializeEvaluataionMaster(), ...data},
    });
  };

  return (
    <FormProvider {...methods}>
      <SubTitle subTitle="작업위험성평가 작성" />
      {isLoading && <MWProgress />}
      <FormSection>
        <form onSubmit={methods.handleSubmit(onSubmit)}>
          <EvaluationMasterForm captionColor="#01579B" />
          {/* <Button
              onClick={() => {
                navigate(`/Permission/CheckPermission/${res?.item?.uid}`, {state: res?.item});
              }}
            >
              저장 및 이동
            </Button> */}
          <ConfirmButtonGroup
            link="/Permission/List"
            cancelText="취소"
            confirmText="저장"
          />
        </form>
      </FormSection>
    </FormProvider>
  );
};

export default CreateDangerEvaluation;
